<ns-fixed-element position="bottom">
    <div class="main">
        <div class="buttons">
            <button kendoButton class="big clear" (click)="onBackClick()">
                {{ backButtonText }}
            </button>

            <button kendoButton class="big" [primary]="true" (click)="onMainClick()" [disabled]="mainButtonDisabled">
                {{ mainButtonText }}
            </button>
        </div>
    </div>
</ns-fixed-element>